module.exports = __webpack_public_path__ + "img/communities.6c0be3a2.svg";